export * from './actions';
export * from './getters';
export * from './mutations';
export * from './state';

export const namespaced = true;
